import * as React from 'react';
import { CloseButton, Modal, ModalWrapper } from '@cian/modal-component';
import { mergeStyles, keepValueInRange } from '@cian/utils';
import * as styles from './AuctionReduceBetModal.css';
import * as PropTypes from 'prop-types';
import { ButtonTheme, Button } from '@cian/button-component';
import { AuctionBetInput } from '../AuctionBetInput';
import { trackAuctionReduceBetPopupShow } from '../AuctionBetManager/tracking';

export interface IAuctionReduceBetModalProps {
  bet: number;
  stepBet: number;
  validateStep: boolean;
  onCancel(): void;
  onSubmit(b: number): void;
  auctionBetCalculator(value: number | null): number;
}

export interface IAuctionReduceBetModalState {
  betValue: number;
  isPending: boolean;
  applyBetOperationId?: number;
  isBetValid: boolean;
}

export class AuctionReduceBetModal extends React.Component<IAuctionReduceBetModalProps, IAuctionReduceBetModalState> {
  public static contextTypes = {
    offer: PropTypes.object,
    auctionMinBet: PropTypes.number,
    auctionMaxBet: PropTypes.number,
  };

  public constructor(props: IAuctionReduceBetModalProps) {
    super(props);

    this.state = {
      betValue: props.bet,
      isPending: false,
      isBetValid: true,
    };
  }

  public componentWillMount() {
    trackAuctionReduceBetPopupShow();
  }

  public render() {
    const { offer } = this.context;
    const { onCancel, stepBet, validateStep, auctionBetCalculator } = this.props;
    const { isBetValid, betValue, isPending } = this.state;

    const closeBtn = (
      <CloseButton onClick={onCancel} />
    );

    return (
      <ModalWrapper onClose={onCancel}>
        <Modal
          minHeight={100}
          minWidth={430}
          maxWidth={430}
          closeBtn={closeBtn}
          contentStyle={{ ...mergeStyles(styles['modal_content']) }}
        >
          <h2 className={styles['title']}>Вы понижаете ставку!</h2>

          <div className={styles['input-row']}>
            <div className={styles['input-label']}>
              Действующая ставка
            </div>
            <div className={styles['input-max_bet']}>
              {offer.auction.currentBet} ₽ в сутки
            </div>
          </div>

          <div className={styles['input-row']}>
            <div className={styles['input-label']}>
              Новая ставка
            </div>
            <AuctionBetInput
              stepBet={stepBet}
              validateStep={validateStep}
              initialBet={betValue}
              onChange={this.handleBetChange}
              auctionBetCalculator={auctionBetCalculator}
            />
          </div>

          <div {...mergeStyles(styles['buttons'], styles['buttons-right'])}>
            <Button type="button" theme={ButtonTheme.Ghost} onClick={onCancel}>Отменить</Button>
            <Button
              type="button"
              disabled={!isBetValid || isPending}
              onClick={this.handlePlaceBetClick}
              isSync={isPending}
            >
              Применить
            </Button>
          </div>
        </Modal>
      </ModalWrapper>
    );
  }

  private handleBetChange = (bet: number) => {
    const { auctionMinBet, auctionMaxBet } = this.context;
    const { validateStep, stepBet, auctionBetCalculator } = this.props;

    const betValue = keepValueInRange(bet, 0, auctionBetCalculator(auctionMaxBet));

    const isMultiplierValid = validateStep ? betValue % stepBet === 0 : true;
    const isBetValid = (betValue === 0 || auctionMinBet <= betValue) && isMultiplierValid;

    this.setState({ betValue, isBetValid });
  }

  private handlePlaceBetClick = () => {
    const { betValue } = this.state;

    this.setState({ isPending: true });

    this.props.onSubmit(betValue);
  }
}
